
<kendo-dialog *ngIf="active"
              class="isg-dialog-editor"
              (close)="closeForm()"
              [height]="(afUiWin.calculatedHeightLarge | async)!"
              [width]="(afUiWin.calculatedWidthMedium | async)!">
  <kendo-dialog-titlebar>
    {{ isNew ? "Add New Role Template" : "Edit Role Template: " + editDataItem!.name }}
  </kendo-dialog-titlebar>

  <form novalidate class="k-form" [formGroup]="editForm">
    <div class="isg-roletemplate-editor-formwrapper">

      <kendo-formfield>
        <kendo-label [for]="name" text="Role Template Name"></kendo-label>
        <kendo-textbox #name
                       formControlName="name"
                       required>
        </kendo-textbox>
        <kendo-formerror>Error: Name is required</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
        <isg-tri-state-checkbox #isActive
                                formControlName="isActive"
                                [nullable]="false"
                                [textTrue]="'Role Template is Active'"
                                [textFalse]="'Role Template Inactive'"
                                [ngClass]="{'isg-isActive': editForm.controls.isActive.value}">
        </isg-tri-state-checkbox>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [for]="roleType" text="Role Type"></kendo-label>
        <kendo-dropdownlist #roleType
                            formControlName="roleType"
                            [data]="roleTypeOptions"
                            [textField]="'name'"
                            [valueField]="'value'"
                            [valuePrimitive]="true"
                            [readonly]="true"
                            style="width:100%;"
                            required>
        </kendo-dropdownlist>
        <kendo-formerror>Error: RoleType is required</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [for]="intDescription" text="Description"></kendo-label>
        <kendo-textarea #intDescription
                        formControlName="intDescription"></kendo-textarea>
      </kendo-formfield>

      <kendo-formfield *ngIf="!isNew">
        <kendo-label text="Last Modified On"></kendo-label>
        <kendo-textbox [readonly]="true"
                       [value]="editDataItem?.lastModifiedOn ? (editDataItem!.lastModifiedOn | utcToLocal) : 'Not available'"></kendo-textbox>
      </kendo-formfield>

      <kendo-formfield *ngIf="!isNew">
        <kendo-label [for]="lastModifiedByName" text="Last Modified By"></kendo-label>
        <kendo-textbox #lastModifiedByName
                       formControlName="lastModifiedByName"
                       [readonly]="true"></kendo-textbox>
      </kendo-formfield>

    </div>

  </form>

  <kendo-dialog-actions>
    <button kendoButton
            themeColor="primary"
            [disabled]="!editForm.valid"
            (click)="onSave($event)">
      {{ isNew ? 'Save' : 'Update' }}
    </button>
    <button kendoButton (click)="onCancel($event)">Cancel</button>

  </kendo-dialog-actions>

</kendo-dialog>
